import React, { FunctionComponent } from 'react';
import { Chip, Grid } from '@rbx/ui';

import useChipsStyles from './Chips.styles';

interface ChipsProps {
  labels: string[];
  className?: string;
}

const Chips: FunctionComponent<React.PropsWithChildren<ChipsProps>> = ({ className, labels }) => {
  const {
    classes: { chip, chipContainer },

    cx,
  } = useChipsStyles();
  if (labels.length === 0) {
    return null;
  }
  return (
    <Grid container className={cx(chipContainer, className)}>
      {labels.map((label) => (
        <Chip className={chip} size='small' key={label} label={label} color='secondary' />
      ))}
    </Grid>
  );
};

export default Chips;
